// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options, urlSearchParamsBodySerializer } from '@hey-api/client-fetch';
import { type GetUserApiV1AdminUserIdGetData, type GetUserApiV1AdminUserIdGetError, type GetUserApiV1AdminUserIdGetResponse, type UpdateUserApiV1AdminUserIdPatchData, type UpdateUserApiV1AdminUserIdPatchError, type UpdateUserApiV1AdminUserIdPatchResponse, type DeleteUserApiV1AdminUserIdDeleteData, type DeleteUserApiV1AdminUserIdDeleteError, type DeleteUserApiV1AdminUserIdDeleteResponse, type GetUsersApiV1AdminUserGetData, type GetUsersApiV1AdminUserGetError, type GetUsersApiV1AdminUserGetResponse, type CreateUserApiV1AdminUserPostData, type CreateUserApiV1AdminUserPostError, type CreateUserApiV1AdminUserPostResponse, type ClearCacheApiV1AdminCacheClearPostError, type ClearCacheApiV1AdminCacheClearPostResponse, type LoginAccessTokenApiV1LoginTokenPostData, type LoginAccessTokenApiV1LoginTokenPostError, type LoginAccessTokenApiV1LoginTokenPostResponse, type GetUserSelfApiV1LoginSelfGetError, type GetUserSelfApiV1LoginSelfGetResponse, type UpdateUserSelfApiV1LoginSelfPatchData, type UpdateUserSelfApiV1LoginSelfPatchError, type UpdateUserSelfApiV1LoginSelfPatchResponse, type GetAssetsApiV1AssetGetData, type GetAssetsApiV1AssetGetError, type GetAssetsApiV1AssetGetResponse, type GetAssetApiV1AssetAssetGetData, type GetAssetApiV1AssetAssetGetError, type GetAssetApiV1AssetAssetGetResponse, type GetAssetFilesApiV1AssetAssetFilesGetData, type GetAssetFilesApiV1AssetAssetFilesGetError, type GetAssetFilesApiV1AssetAssetFilesGetResponse, type GetCategoriesApiV1CategoriesGetData, type GetCategoriesApiV1CategoriesGetError, type GetCategoriesApiV1CategoriesGetResponse, type GetCategoryObjectsApiV1CategoriesCatGetData, type GetCategoryObjectsApiV1CategoriesCatGetError, type GetCategoryObjectsApiV1CategoriesCatGetResponse, type FilterCategoryObjectsApiV1CategoriesCatFilterGetData, type FilterCategoryObjectsApiV1CategoriesCatFilterGetError, type FilterCategoryObjectsApiV1CategoriesCatFilterGetResponse, type GetFilesApiV1FileGetData, type GetFilesApiV1FileGetError, type GetFilesApiV1FileGetResponse, type GetFileApiV1FileFileGetData, type GetFileApiV1FileFileGetError, type GetFileApiV1FileFileGetResponse, type GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetData, type GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetError, type GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetResponse, type GetObjectsApiV1ObjectGetData, type GetObjectsApiV1ObjectGetError, type GetObjectsApiV1ObjectGetResponse, type GetObjectApiV1ObjectObjGetData, type GetObjectApiV1ObjectObjGetError, type GetObjectApiV1ObjectObjGetResponse, type GetObjectAssetsApiV1ObjectObjAssetsGetData, type GetObjectAssetsApiV1ObjectObjAssetsGetError, type GetObjectAssetsApiV1ObjectObjAssetsGetResponse, type FilterObjectApiV1ObjectFilterGetData, type FilterObjectApiV1ObjectFilterGetError, type FilterObjectApiV1ObjectFilterGetResponse, GetAssetsApiV1AssetGetResponseTransformer, GetAssetApiV1AssetAssetGetResponseTransformer, GetAssetFilesApiV1AssetAssetFilesGetResponseTransformer, GetFilesApiV1FileGetResponseTransformer, GetFileApiV1FileFileGetResponseTransformer, GetObjectAssetsApiV1ObjectObjAssetsGetResponseTransformer } from './types.gen';

/**
 * Get User
 */
export const getUserApiV1AdminUserIdGet = (options: Options<GetUserApiV1AdminUserIdGetData>) => { return (options?.client ?? client).get<GetUserApiV1AdminUserIdGetResponse, GetUserApiV1AdminUserIdGetError>({
    ...options,
    url: '/api/v1/admin/user/{id}'
}); };

/**
 * Update User
 */
export const updateUserApiV1AdminUserIdPatch = (options: Options<UpdateUserApiV1AdminUserIdPatchData>) => { return (options?.client ?? client).patch<UpdateUserApiV1AdminUserIdPatchResponse, UpdateUserApiV1AdminUserIdPatchError>({
    ...options,
    url: '/api/v1/admin/user/{id}'
}); };

/**
 * Delete User
 */
export const deleteUserApiV1AdminUserIdDelete = (options: Options<DeleteUserApiV1AdminUserIdDeleteData>) => { return (options?.client ?? client).delete<DeleteUserApiV1AdminUserIdDeleteResponse, DeleteUserApiV1AdminUserIdDeleteError>({
    ...options,
    url: '/api/v1/admin/user/{id}'
}); };

/**
 * Get Users
 */
export const getUsersApiV1AdminUserGet = (options?: Options<GetUsersApiV1AdminUserGetData>) => { return (options?.client ?? client).get<GetUsersApiV1AdminUserGetResponse, GetUsersApiV1AdminUserGetError>({
    ...options,
    url: '/api/v1/admin/user/'
}); };

/**
 * Create User
 */
export const createUserApiV1AdminUserPost = (options: Options<CreateUserApiV1AdminUserPostData>) => { return (options?.client ?? client).post<CreateUserApiV1AdminUserPostResponse, CreateUserApiV1AdminUserPostError>({
    ...options,
    url: '/api/v1/admin/user/'
}); };

/**
 * Clear Cache
 */
export const clearCacheApiV1AdminCacheClearPost = (options?: Options) => { return (options?.client ?? client).post<ClearCacheApiV1AdminCacheClearPostResponse, ClearCacheApiV1AdminCacheClearPostError>({
    ...options,
    url: '/api/v1/admin/cache/clear'
}); };

/**
 * Login Access Token
 * Create an access token for login
 */
export const loginAccessTokenApiV1LoginTokenPost = (options: Options<LoginAccessTokenApiV1LoginTokenPostData>) => { return (options?.client ?? client).post<LoginAccessTokenApiV1LoginTokenPostResponse, LoginAccessTokenApiV1LoginTokenPostError>({
    ...options,
    ...urlSearchParamsBodySerializer,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/api/v1/login/token'
}); };

/**
 * Get User Self
 * Get own user.
 */
export const getUserSelfApiV1LoginSelfGet = (options?: Options) => { return (options?.client ?? client).get<GetUserSelfApiV1LoginSelfGetResponse, GetUserSelfApiV1LoginSelfGetError>({
    ...options,
    url: '/api/v1/login/self'
}); };

/**
 * Update User Self
 * Update own user.
 */
export const updateUserSelfApiV1LoginSelfPatch = (options?: Options<UpdateUserSelfApiV1LoginSelfPatchData>) => { return (options?.client ?? client).patch<UpdateUserSelfApiV1LoginSelfPatchResponse, UpdateUserSelfApiV1LoginSelfPatchError>({
    ...options,
    url: '/api/v1/login/self'
}); };

/**
 * Get Assets
 */
export const getAssetsApiV1AssetGet = (options?: Options<GetAssetsApiV1AssetGetData>) => { return (options?.client ?? client).get<GetAssetsApiV1AssetGetResponse, GetAssetsApiV1AssetGetError>({
    ...options,
    url: '/api/v1/asset/',
    responseTransformer: GetAssetsApiV1AssetGetResponseTransformer
}); };

/**
 * Get Asset
 */
export const getAssetApiV1AssetAssetGet = (options: Options<GetAssetApiV1AssetAssetGetData>) => { return (options?.client ?? client).get<GetAssetApiV1AssetAssetGetResponse, GetAssetApiV1AssetAssetGetError>({
    ...options,
    url: '/api/v1/asset/{asset}',
    responseTransformer: GetAssetApiV1AssetAssetGetResponseTransformer
}); };

/**
 * Get Asset Files
 */
export const getAssetFilesApiV1AssetAssetFilesGet = (options: Options<GetAssetFilesApiV1AssetAssetFilesGetData>) => { return (options?.client ?? client).get<GetAssetFilesApiV1AssetAssetFilesGetResponse, GetAssetFilesApiV1AssetAssetFilesGetError>({
    ...options,
    url: '/api/v1/asset/{asset}/files',
    responseTransformer: GetAssetFilesApiV1AssetAssetFilesGetResponseTransformer
}); };

/**
 * Get Categories
 */
export const getCategoriesApiV1CategoriesGet = (options?: Options<GetCategoriesApiV1CategoriesGetData>) => { return (options?.client ?? client).get<GetCategoriesApiV1CategoriesGetResponse, GetCategoriesApiV1CategoriesGetError>({
    ...options,
    url: '/api/v1/categories/'
}); };

/**
 * Get Category Objects
 */
export const getCategoryObjectsApiV1CategoriesCatGet = (options: Options<GetCategoryObjectsApiV1CategoriesCatGetData>) => { return (options?.client ?? client).get<GetCategoryObjectsApiV1CategoriesCatGetResponse, GetCategoryObjectsApiV1CategoriesCatGetError>({
    ...options,
    url: '/api/v1/categories/{cat}/'
}); };

/**
 * Filter Category Objects
 */
export const filterCategoryObjectsApiV1CategoriesCatFilterGet = (options: Options<FilterCategoryObjectsApiV1CategoriesCatFilterGetData>) => { return (options?.client ?? client).get<FilterCategoryObjectsApiV1CategoriesCatFilterGetResponse, FilterCategoryObjectsApiV1CategoriesCatFilterGetError>({
    ...options,
    url: '/api/v1/categories/{cat}/filter/'
}); };

/**
 * Get Files
 */
export const getFilesApiV1FileGet = (options?: Options<GetFilesApiV1FileGetData>) => { return (options?.client ?? client).get<GetFilesApiV1FileGetResponse, GetFilesApiV1FileGetError>({
    ...options,
    url: '/api/v1/file/',
    responseTransformer: GetFilesApiV1FileGetResponseTransformer
}); };

/**
 * Get File
 */
export const getFileApiV1FileFileGet = (options: Options<GetFileApiV1FileFileGetData>) => { return (options?.client ?? client).get<GetFileApiV1FileFileGetResponse, GetFileApiV1FileFileGetError>({
    ...options,
    url: '/api/v1/file/{file}',
    responseTransformer: GetFileApiV1FileFileGetResponseTransformer
}); };

/**
 * Get Image
 */
export const getImageApiV1ImageFileRegionSizeRotationQualityImageFormatGet = (options: Options<GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetData>) => { return (options?.client ?? client).get<GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetResponse, GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetError>({
    ...options,
    url: '/api/v1/image/{file}/{region}/{size}/{rotation}/{quality}.{image_format}'
}); };

/**
 * Get Objects
 */
export const getObjectsApiV1ObjectGet = (options?: Options<GetObjectsApiV1ObjectGetData>) => { return (options?.client ?? client).get<GetObjectsApiV1ObjectGetResponse, GetObjectsApiV1ObjectGetError>({
    ...options,
    url: '/api/v1/object/'
}); };

/**
 * Get Object
 */
export const getObjectApiV1ObjectObjGet = (options: Options<GetObjectApiV1ObjectObjGetData>) => { return (options?.client ?? client).get<GetObjectApiV1ObjectObjGetResponse, GetObjectApiV1ObjectObjGetError>({
    ...options,
    url: '/api/v1/object/{obj}'
}); };

/**
 * Get Object Assets
 */
export const getObjectAssetsApiV1ObjectObjAssetsGet = (options: Options<GetObjectAssetsApiV1ObjectObjAssetsGetData>) => { return (options?.client ?? client).get<GetObjectAssetsApiV1ObjectObjAssetsGetResponse, GetObjectAssetsApiV1ObjectObjAssetsGetError>({
    ...options,
    url: '/api/v1/object/{obj}/assets',
    responseTransformer: GetObjectAssetsApiV1ObjectObjAssetsGetResponseTransformer
}); };

/**
 * Filter Object
 */
export const filterObjectApiV1ObjectFilterGet = (options?: Options<FilterObjectApiV1ObjectFilterGetData>) => { return (options?.client ?? client).get<FilterObjectApiV1ObjectFilterGetResponse, FilterObjectApiV1ObjectFilterGetError>({
    ...options,
    url: '/api/v1/object/filter/'
}); };